import(/* webpackMode: "eager" */ "/vercel/path0/app/cookies/page.tsx")